import { useState, useRef } from "react";

import { Swiper, SwiperSlide, Autoplay, Pagination, Navigation } from './swiper-helper';
import { arrayAny, arrayHasMoreThanNItems } from "../../utils/arrayUtils";

const ImageElementInner = ({ image, setShowEditImageModal, setStarRating, readOnly, contextLabel, preferFullRes }) => {
    const inActiveStars = 5 - (image.rating || 0);
    const keys = [...Array(image.rating || 0).keys()];
    const inactiveKeys = [...Array(inActiveStars).keys()];

    return (
        <div className="gallery-item" onClick={() => { if (!readOnly && typeof setShowEditImageModal === "function") { setShowEditImageModal({ image }); } }}>
            {image.isPrimaryImage && (
                <div className="primary-badge">Primary</div>
            )}
            
            <div className="gallery-item-image">
                <img
                    src={preferFullRes
                        ? (image.pathIncSASToken || image.thumbPathIncSASToken)
                        : (image.thumbPathIncSASToken || image.pathIncSASToken)}
                    alt={image.title || 'Property photo'}
                />
                <div className="gallery-item-overlay"></div>
                {image.caption && (
                    <div className="gallery-item-caption">{image.caption}</div>
                )}
            </div>
            
            <div className="gallery-item-info">
                <h5 className="gallery-item-title">{image.title || 'Untitled Photo'}</h5>
                
                {contextLabel && (
                    <div className="gallery-item-context text-muted small">{contextLabel}</div>
                )}

                {image.description && (
                    <div className="gallery-item-description">{image.description}</div>
                )}
                
                <div className="gallery-item-meta">
                    {!readOnly && typeof setStarRating === "function" && (
                        <div onClick={e => e.stopPropagation()} className="gallery-rating">
                            {keys.map(k =>
                                <i 
                                    key={`active-${k}`}
                                    className="fa fa-star star active"
                                    onClick={() => setStarRating(image, k + 1)}
                                ></i>
                            )}
                            {inactiveKeys.map(k =>
                                <i 
                                    key={`inactive-${k}`}
                                    className="fa fa-star star inactive"
                                    onClick={() => setStarRating(image, (image.rating || 0) + k + 1)}
                                ></i>
                            )}
                        </div>
                    )}
                    
                    {image.updatedBy && image.updatedBy.displayName && (
                        <div className="gallery-modified-by">
                            <small>Modified by</small>
                            <div>{image.updatedBy.displayName}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export const ImageGalleryElement = (props) => {

    const myRef = useRef(null);
    const [slideShow, setSlideShow] = useState(false);
    const enableSlideshow = props.enableSlideshow !== false; // default to true unless explicitly disabled

    const toggleSlideShow = () => {
        if (!enableSlideshow) return;
        setSlideShow(current => !current);
    };

    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
        progressCircle.current.style.setProperty('--progress', 1 - progress);
        progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    };

    const fullscreenStyle = {
        position: "fixed",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        zIndex: 10
    };


    return (
        <>
            {enableSlideshow && slideShow && arrayAny(props.photos) &&
                <Swiper
                    ref={myRef}
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    onClick={() => toggleSlideShow()}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    onAutoplayTimeLeft={arrayHasMoreThanNItems(props.photos, 1) ? onAutoplayTimeLeft : null}
                    className="mySwiper"
                    style={fullscreenStyle}
                >
                    {props.photos.map((image, i) =>
                        <SwiperSlide key={`swiper-slide-${i}`}>
                            <div>
                                {
                                    // TODO: fix image ratios
                                    //"<img style={{/*maxWidth: 350 + 'px',*/  maxHeight: 375 + 'px' }} src={image.pathIncSASToken} alt="" />"
                                }
                                <img src={image.pathIncSASToken} alt="" />
                            </div>
                        </SwiperSlide>
                    )}


                    <div className="autoplay-progress" slot="container-end">
                        <svg viewBox="0 0 48 48" ref={progressCircle}>
                            <circle cx="24" cy="24" r="20"></circle>
                        </svg>
                        <span ref={progressContent}></span>
                    </div>
                </Swiper>
            }
            {!slideShow && (
                <>
                    {arrayAny(props.photos) ? (
                        <div className="gallery-grid">
                            {props.photos.map(i => {
                                const contextLabel = typeof props.getImageContextLabel === "function" ? props.getImageContextLabel(i) : null;
                                return (
                                <ImageElementInner 
                                    key={i.thumbPathIncSASToken || i.pathIncSASToken} 
                                    image={i} 
                                    setShowEditImageModal={props.setShowEditImageModal} 
                                    setStarRating={props.setStarRating}
                                    readOnly={props.readOnly}
                                    preferFullRes={props.preferFullRes}
                                    contextLabel={contextLabel}
                                />
                            );})}
                        </div>
                    ) : (
                        <div className="gallery-empty-state">
                            <i className="fa fa-images"></i>
                            <h4>No Photos Added</h4>
                            <p>Add photos to showcase this property</p>
                        </div>
                    )}
                    
                    {enableSlideshow && arrayAny(props.photos) && !props.readOnly && (
                        <div className="d-flex justify-content-center">
                            <button 
                                className="btn btn-slideshow"
                                onClick={() => toggleSlideShow()}
                                title="Start Slideshow"
                            >
                                <i className="fa fa-play"></i>&nbsp;&nbsp;Start Slideshow
                            </button>
                        </div>
                    )}
                </>
            )}
        </>
    );


}